import { httpClient } from '@/api/httpClient';
import {
  resolveAttachmentFilename,
  type DownloadedFile,
} from '@/api/fileDownload';
import {
  mapApiResourceToImportCommitResult,
  mapApiResourceToImportPreview,
  mapImportPreviewRowToCommitPayload,
  type ImportCommitResult,
  type ImportCommitResultApiResource,
  type ImportPreview,
  type ImportPreviewApiResource,
  type ImportPreviewRow,
} from './clientImportsApi.types';

const DEFAULT_TEMPLATE_FILENAME = 'client-import-template.csv';

export async function downloadImportTemplate(): Promise<DownloadedFile> {
  const response = await httpClient.get<Blob>('/client-imports/template', {
    responseType: 'blob',
  });
  return {
    blob: response.data,
    filename: resolveAttachmentFilename(
      response.headers['content-disposition'],
      DEFAULT_TEMPLATE_FILENAME
    ),
  };
}

export async function validateImportFile(file: File): Promise<ImportPreview> {
  const formData = new FormData();
  formData.append('file', file);
  const response = await httpClient.post<ImportPreviewApiResource>(
    '/client-imports/validate',
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return mapApiResourceToImportPreview(response.data);
}

export async function commitImport(
  rows: ImportPreviewRow[],
  idempotencyKey: string
): Promise<ImportCommitResult> {
  const response = await httpClient.post<ImportCommitResultApiResource>('/client-imports/commit', {
    rows: rows.map(mapImportPreviewRowToCommitPayload),
    idempotency_key: idempotencyKey,
  });
  return mapApiResourceToImportCommitResult(response.data);
}
